var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article"}},[_c('div',{staticClass:"home-head"},[_c('head-common')],1),_vm._v(" "),_c('div',{staticClass:"article-details-components"},[_c('article-details-person',{attrs:{"article":_vm.articleParam}})],1),_vm._v(" "),_c('div',{staticClass:"home-footer"},[_c('footer-common')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d2dcba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hpage/ArticleDetailsPage.vue
// module id = null
// module chunks = 